/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BucketLifecycleRule { 
    name?: string;
    state?: string;
    /**
     * Expiration in days
     */
    expiration_in_days?: number;
    /**
     * Expiration date
     */
    expiration_date?: Date;
}

